
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcIconCheckButton as ObcIconCheckButtonElement} from '@oicl/openbridge-webcomponents/dist/components/icon-check-button/icon-check-button.js';
 
 
 

 
 export const ObcIconCheckButton = createComponent({
   react: React,
   tagName: 'obc-icon-check-button',
   elementClass: ObcIconCheckButtonElement,
   events: {
     
     onIconCheckButtonClick: 'icon-check-button-click' as EventName<CustomEvent<{checked: boolean}>>,
   }
  });
 
 